/* eslint-disable react/display-name */
import React, { memo } from 'react';

import { OutdoorSportsIconColors } from './iconConstants';
import { IconProps } from './iconInterfaces';

export const CircleSolidColorIcon = memo(({ 
    backgroundFillColor = OutdoorSportsIconColors.BackgroundFillColor,
    width = 40,
    height = 40,
    displayValue
}: IconProps) =>
    <svg width={width} height={height} viewBox='0 0 64 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <circle cx='32' cy='32' r='32' fill={backgroundFillColor} />
        <text 
            x='50%' 
            y='50%' 
            textAnchor='middle' 
            stroke='white' 
            strokeWidth='3px' 
            dy='.3em' 
            fontSize='40px' 
            fontFamily='Source Sans Pro'  
            fontWeight='300'
            fontStyle='normal'>
            {displayValue}
        </text>
    </svg>
);
